import { render, staticRenderFns } from "./FilePage.vue?vue&type=template&id=098ea334&scoped=true&"
import script from "./FilePage.vue?vue&type=script&lang=ts&"
export * from "./FilePage.vue?vue&type=script&lang=ts&"
import style0 from "./FilePage.vue?vue&type=style&index=0&id=098ea334&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ea334",
  null
  
)

export default component.exports